
const useIsDoctor = () => {
  const params = new URLSearchParams(window.location.search);
  const isDoctorParam = params.get("isDoctor");
  const isDoctor = isDoctorParam === "true"; // Convert to boolean
 return isDoctor;
};

export default useIsDoctor;
